import firebase from 'firebase/app';
import 'firebase/firestore'

const config = {
  apiKey: 'AIzaSyBDvMbMKn1a9_Da7h-JsmHCw5STNuh5ftM',
  authDomain: 'ioi-platform.firebaseapp.com',
  databaseURL: 'https://ioi-platform.firebaseio.com',
  projectId: 'ioi-platform',
  storageBucket: 'ioi-platform.appspot.com',
  messagingSenderId: '54373521016',
  appId: '1:54373521016:web:bf5858974cbc42759bff8d',
  measurementId: 'G-ZQWK66QB3B',
};

const settings = { // timestampsInSnapshots: true 
};
firebase.initializeApp(config);
firebase.firestore().settings(settings);

export default firebase;